import { ISimpleTableRow } from "@asup/simple-table";

/**
 * Searches TLF templates by text matching AZSOL ID, title, or TOC label.
 *
 * @param row - Table row to search
 * @param searchText - Search text to match
 */
export const searchTemplatesWithText = (row: ISimpleTableRow, searchText: string) =>
  `${row.azsolIdVersion ?? ""}`.toLowerCase().includes(searchText.toLowerCase().trim()) ||
  `${row.title ?? ""}`.toLowerCase().includes(searchText.toLowerCase().trim()) ||
  `${row.tocLabel ?? ""}`.toLowerCase().includes(searchText.toLowerCase().trim());
